import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Root shell component — pure router outlet.
 * All visual chrome lives in HomeComponent (protected routes).
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class AppComponent {}
